import { styled } from "@mui/material/styles";
import Tooltip, { TooltipProps, tooltipClasses } from "@mui/material/Tooltip";

export const ButtonTooltip = styled(({ className, ...props }: TooltipProps) => <Tooltip {...props} arrow classes={{ popper: className }} />)(({}) => ({
    [`& .${tooltipClasses.arrow}`]: {
        color: "#333333"
    },
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: "#333333",
        fontFamily: "proxima-nova, sans-serif",
        fontSize: "0.875rem",
        fontWeight: "600",
        borderRadius: ".5rem",
        padding: ".5rem .75rem"
    }
}));
